import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "../context/WishlistContext";

export default function HeartButton({ id, name, className = "", size = 16, dark = false, style }) {
  const { has, toggle } = useWishlist();
  const on = has(id);
  return (
    <motion.button
      type="button"
      data-testid={`wishlist-toggle-${id}`}
      aria-label={on ? "Remove from wishlist" : "Save to wishlist"}
      aria-pressed={on}
      whileTap={{ scale: 0.8 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(id);
        toast(on ? `${name} removed from your wishlist` : `${name} saved to your wishlist`);
      }}
      style={style}
      className={`inline-flex items-center justify-center rounded-full w-9 h-9 transition-colors ${
        on ? "bg-gold text-ink" : dark ? "bg-obsidian/60 text-ivory hover:bg-gold hover:text-ink" : "bg-ivory/90 text-ink hover:bg-gold"
      } ${className}`}
    >
      <motion.span animate={on ? { scale: [1, 1.35, 1] } : { scale: 1 }} transition={{ duration: 0.4 }} className="flex">
        <Heart size={size} strokeWidth={1.6} fill={on ? "currentColor" : "none"} />
      </motion.span>
    </motion.button>
  );
}
